import Styled from 'styled-components'

export default Styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 -0.25rem;
  
  & > * {
    min-width: 0;
    width: calc(100% / ${props => props.amount});
    margin: 0 0.25rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/ThemeOptions/index.js